import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getProjectEquipmentAvailableColumns } from './api';

export const path = '/ppr/project-equipment/list';

const PageEquipments: React.FC = (props) => {
  const Equipments = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getProjectEquipmentAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} columns={loaded.columns} />;
    },
  });

  return <Equipments {...props} />;
};

export default PageEquipments;
